"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const Pagination_styles_1 = require("./Pagination.styles");
const Pagination = props => {
  const {
    total,
    onChange,
    current = 4
  } = props;
  const first = 1;
  const last = total < first ? 1 : total;
  const canShowAll = last <= 5;
  const isHeadDetached = !canShowAll && current - 3 > first;
  const isTailDetached = !canShowAll && current + 3 < last;
  const getMiddle = () => {
    if (first === last) {
      return [];
    }
    if (last <= 5) {
      return new Array(last - 2).fill(undefined).map((e, i) => i + 2);
    }
    if (first === current || current < 5) {
      return [2, 3, 4, 5];
    }
    if (last === current || last - current < 4) {
      return [last - 4, last - 3, last - 2, last - 1];
    }
    return [current - 1, current, current + 1];
  };
  const onBackClick = () => {
    if (current !== first) {
      onChange(current - 1);
    }
  };
  const onNextClick = () => {
    if (current !== last) {
      onChange(current + 1);
    }
  };
  return (0, jsx_runtime_1.jsxs)(Pagination_styles_1.Container, {
    children: [(0, jsx_runtime_1.jsx)(Pagination_styles_1.Button, {
      disabled: current === first,
      isDisabled: current === first,
      onClick: onBackClick,
      children: (0, jsx_runtime_1.jsx)(Pagination_styles_1.ChevronLeft, {})
    }), (0, jsx_runtime_1.jsx)(Pagination_styles_1.Button, {
      isActive: current === first,
      onClick: () => {
        onChange(first);
      },
      children: first
    }), isHeadDetached && (0, jsx_runtime_1.jsx)(Pagination_styles_1.Button, {
      onClick: () => {
        onChange(current - 5 < 1 ? 1 : current - 5);
      },
      children: (0, jsx_runtime_1.jsx)(Pagination_styles_1.DotsLeft, {})
    }), getMiddle().map(page => (0, jsx_runtime_1.jsx)(Pagination_styles_1.Button, {
      isActive: page === current,
      onClick: () => {
        onChange(page);
      },
      children: page
    }, page)), isTailDetached && (0, jsx_runtime_1.jsx)(Pagination_styles_1.Button, {
      onClick: () => {
        onChange(current + 5 > last ? last : current + 5);
      },
      children: (0, jsx_runtime_1.jsx)(Pagination_styles_1.DotsRight, {})
    }), first !== last && (0, jsx_runtime_1.jsx)(Pagination_styles_1.Button, {
      isActive: current === last,
      onClick: () => {
        onChange(last);
      },
      children: last
    }), (0, jsx_runtime_1.jsx)(Pagination_styles_1.Button, {
      disabled: current === last,
      isDisabled: current === last,
      onClick: onNextClick,
      children: (0, jsx_runtime_1.jsx)(Pagination_styles_1.ChevronRight, {})
    })]
  });
};
exports.default = Pagination;